import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

const fetchUserGroups = async (params = {}) => {  
  // Build query string for filtering
  const queryParams = new URLSearchParams();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  if (params.name) queryParams.append('name', params.name);
  if (params.page !== undefined && params.page !== null) queryParams.append('page', params.page);
  if (params.idList && params.idList.length > 0) {
    queryParams.append('idList', params.idList.join(','));
  }
  
  const queryString = queryParams.toString();
  const url = `${prefix}/user/groups${queryString ? '?' + queryString : ''}`;
  
  const response = await restClient({ 
    url: url,
    method: 'get'
  });
  return response;
};

export const useUserGroups = (params = {}, options = {}) => {
  const { enabled = true } = options;
  const queryKey = ['userGroups', params];
  
  
  const queryResult = useQuery({
    queryKey,
    queryFn: () => fetchUserGroups(params),
    enabled,
    staleTime: 0,
    cacheTime: 0, 
    retry: 2
  });

  // Return the raw response without manipulations
  return {
    data: queryResult.data,
    isLoading: queryResult.isLoading,
    error: queryResult.error,
    refetch: queryResult.refetch,
    // GraphQL compatibility
    loading: queryResult.isLoading,
  };
};
